import { getDateString, getTimeString } from "../utils/date-utils";


/**
 * Method to filter all matches to only the given day matches
 * @param {*} responseData object from get_all_matches in https://www.academiadasapostas.com/api/?mode=web&timezone=Europe/
 * @param {String} dateString date in aaaa-mm-dd format
 */
export function filterGamesByDay(responseData, dateString) {
    let filteredData = responseData.filter(match => (
        match.date_utc === dateString
    ));
    return filteredData;
}

export function removeDuplicatedChannel(zappingArray) {
    let zappingWithoutDuplicates = [];
    if (zappingArray.length > 0) {
        let uniqueChannelIds = [];
        zappingArray.forEach(channel => {
            if (!uniqueChannelIds.includes(channel.channel_id)) {
                //add channel id
                uniqueChannelIds.push(channel.channel_id);
                //add channel object to zapping array
                zappingWithoutDuplicates.push(channel);
            }
        })
    }
    return zappingWithoutDuplicates;
}


export function adpatGamesToUsersTimeZone(responseData) {
    let gamesByDate = {}

    const minOffset = new Date().getTimezoneOffset() * (-1);
    responseData.forEach(game => {
        const splitedGameDate = game.date_utc.split("-");
        const gameDateYear = Number(splitedGameDate[0]);
        const gameDateMonth = Number(splitedGameDate[1]) - 1;
        const gameDateDay = Number(splitedGameDate[2]);
        const splitedGameTime = game.time_utc.split(":");
        const gameTimeHour = Number(splitedGameTime[0]);
        const gameTimeMinute = Number(splitedGameTime[1]);
        const gameTimeSecond = Number(splitedGameTime[2]);
        const gameInGmtDate = new Date(gameDateYear, gameDateMonth, gameDateDay, gameTimeHour, gameTimeMinute, gameTimeSecond);
        let gameInUsersDate = new Date();
        gameInUsersDate.setTime(gameInGmtDate.getTime() + (minOffset * 60 * 1000));
        const gameInUsersDateString = getDateString(gameInUsersDate);

        let adpatedGame = { ...game }
        adpatedGame.date_utc = gameInUsersDateString;
        adpatedGame.time_utc = getTimeString(gameInUsersDate);

        if (game.hasOwnProperty("zapping")) {
            adpatedGame.zapping = removeDuplicatedChannel(game.zapping);
        }

        if (!gamesByDate.hasOwnProperty(gameInUsersDateString)) {
            gamesByDate[gameInUsersDateString] = [];
        }

        gamesByDate[gameInUsersDateString].push(adpatedGame)
    })
    return gamesByDate;
}

export function adpatedGameTimeUser(game) {
    const minOffset = new Date().getTimezoneOffset() * (-1);

    const gameInGmtDate = new Date(game.date_utc + "T" + game.time_utc);
    let gameInUsersDate = new Date();
    gameInUsersDate.setTime(gameInGmtDate.getTime() + (minOffset * 60 * 1000));
    const gameInUsersDateString = getDateString(gameInUsersDate);

    let adpatedGame = { ...game }
    adpatedGame.date_utc = gameInUsersDateString;
    adpatedGame.time_utc = getTimeString(gameInUsersDate);

    return adpatedGame
}